import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { PageResponse } from "../api/dto/paginacao/page-response";
import { HttpParamsUtil } from "../util/http-params-util";
import { PageRequest } from "../api/dto/paginacao/page-request";
import { DateUtil } from "../util/date-util";

@Injectable({
    providedIn: 'root',
})
export class AgendaEmpresaItemServicoService {

    constructor(private http: HttpClient) { }
    
        private url: string = UrlServidor.URL_BASE + 'agenda-empresa-itens-servicos';

        

}
